<template src="./dettaglioCliente.html"></template>


<script>
import TabellaFatturato from "@/components/statistiche/TabellaFatturato.vue";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    item: { type: Object, default: null },
    filtroTipologia: { type: String, default: "" },
    annoSel: { type: Number, default: 0 },
    userSwitch: { type: Object, default: null },
    role: { type: String, default: "" },
    dataDa: { type: String, default: "" },
    dataA: { type: String, default: "" },
    dataDa2: { type: String, default: "" },
    dataA2: { type: String, default: "" },
  },

  components: {
    TabellaFatturato,
  },

  data: () => ({
    dati: [],
  }),

  methods: {
    async caricaDati() {
      if (
        this.item == null ||
        this.item == undefined ||
        this.item == {} ||
        this.userSwitch == null
      ) {
        this.chiudiDialog();
        return;
      }
    },

    chiudiDialog() {
      this.$emit("chiudiDialog", true);
    },
  },
  mounted() {
    this.caricaDati();
  },

  watch: {
    dialog(val) {
      if (!val) return;
      this.caricaDati();
    },
  },
};
</script>